

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/shared/Layout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Employee from "./pages/Employee";
import Attendance from "./pages/Attendance";
import Leaves from "./pages/Leaves";
import Task from "./pages/Task";
import TasksTitle from "./pages/TasksTitle";
import Logout from "./pages/Logout";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./private/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import CreateTaskTitle from "./pages/CreateTaskTitle";
import CreateHoliday from "./pages/CreateHoliday";
import ViewHoliday from "./pages/ViewHoliday";
import CreateRole from "./pages/CreateRole";
import CreatePermission from "./pages/CreatePermission";
import AssignPermission from "./pages/AssignPermissionToRole";
import Geofence from "./pages/geofence";
import TaskTracking from "./pages/TaskTracking"; 
import VisitLocation from "./pages/visitLocation"; 
import CreateVisitLocation from "./pages/CreateVisitLocation";
import AddUser from "./pages/AddUser"; 
import UserAddBulk from "./pages/UserAddBulk"; 
import CreateLeaveType from "./pages/Leave Management/CreateLeaveType";
import EditLeaveType from "./pages/Leave Management/EditLeaveType"; 
import LeaveTypes from "./pages/Leave Management/LeaveTypes";
import EmployeesRemainingLeaves from "./pages/Leave Management/EmployeesRemainingLeaves";
import Designations from "./pages/Designations/Designations";
import CreateDesignation from "./pages/Designations/createDesignation";
import Viewdistricts from "./pages/Viewdistricts";
import ViewMunicipalitie from "./pages/ViewMunicipalitie";
import CreateDistricts from "./pages/Districts/CreateDistricts";
import CreateMunicipality from "./pages/Municipality/CreateMunicipality";
import ViewAdmin from "./pages/viewAdmin";
import CreateAdmin from "./pages/admin/CreateAdmin";
import ParkGeofence from "./pages/parkGeofence";
import CreateTasksAdmin from "./pages/CreateTasksAdmin";
import ContactDetails from "./pages/web_admin/ContactDetails";
import ResumeDetails from "./pages/web_admin/ResumeDetails";
import Blog from "./pages/web_admin/blog/Blog.tsx";
import Job from "./pages/web_admin/job/Jobs.tsx";
import ResetPasswordPage  from "./pages/admin/ResetPasswordPage";
import CreateOffice from "./pages/Office/CreateOffice";
import ViewOffice from "./pages/Office/ViewOffice";
import CreateShift from "./pages/shift/CreateShift";
import ViewShifts from "./pages/shift/ViewShift";
import AttendanceReport from "./pages/AttendanceReport";
import DirectAttendance from "./pages/directAttendance";





const App = () => {
  return (
    <AuthProvider>
      <Router>
       
        <Toaster
          position="top-right"
          toastOptions={{ style: { background: "#f2f2f2", color: "#000000" } }}
        />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          <Route path="/dashboard/*" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<ProtectedRoute requiredPermissions={["view_dashboard"]}><Dashboard /></ProtectedRoute>} />
            <Route path="employee" element={<ProtectedRoute requiredPermissions={["manage_users"]}><Employee /></ProtectedRoute>} />
            <Route path="reset-password" element={<ProtectedRoute requiredPermissions={["manage_users"]}><ResetPasswordPage  /></ProtectedRoute>} />
            <Route path="attendance" element={<ProtectedRoute requiredPermissions={["view_attendance"]}><Attendance /></ProtectedRoute>} />
            <Route path="leaves" element={<ProtectedRoute requiredPermissions={["view_leaves"]}><Leaves /></ProtectedRoute>} />
            <Route path="task" element={<ProtectedRoute requiredPermissions={["view_tasks"]}><Task /></ProtectedRoute>} />
            <Route path="task-title" element={<ProtectedRoute requiredPermissions={["view_tasks_title"]}><TasksTitle /></ProtectedRoute>} />
            <Route path="create-task-title" element={<ProtectedRoute requiredPermissions={["create_tasks_title"]}><CreateTaskTitle /></ProtectedRoute>} />
            <Route path="view-holiday" element={<ProtectedRoute requiredPermissions={["view_holiday"]}><ViewHoliday /></ProtectedRoute>} />
            <Route path="create-holiday" element={<ProtectedRoute requiredPermissions={["create_holiday"]}><CreateHoliday /></ProtectedRoute>} />
            <Route path="create-role" element={<ProtectedRoute requiredPermissions={["create_role"]}><CreateRole /></ProtectedRoute>} />
            <Route path="create-permission" element={<ProtectedRoute requiredPermissions={["create_permission"]}><CreatePermission /></ProtectedRoute>} />
            <Route path="assign-permission" element={<ProtectedRoute requiredPermissions={["assign_permission_to_role"]}><AssignPermission /></ProtectedRoute>} />
            <Route path="geofence" element={<ProtectedRoute requiredPermissions={["view_geofence"]}><Geofence /></ProtectedRoute>} />
            <Route path="task-tracking" element={<ProtectedRoute requiredPermissions={["view_tasks_track"]}><TaskTracking /></ProtectedRoute>} />
            <Route path="visit-Location" element={<ProtectedRoute requiredPermissions={["view_locations_Dropdown"]}><VisitLocation /></ProtectedRoute>} />
            <Route path="Create-Visit-Location" element={<ProtectedRoute requiredPermissions={["create_locations_Dropdown"]}><CreateVisitLocation /></ProtectedRoute>} />
            <Route path="User-add" element={<ProtectedRoute requiredPermissions={["User_add"]}><AddUser /></ProtectedRoute>} />
            <Route path="User-add-bulk" element={<ProtectedRoute requiredPermissions={["User_Add_Bulk"]}><UserAddBulk /></ProtectedRoute>} />
            <Route path="create-leave-type" element={<ProtectedRoute requiredPermissions={["create_leave_types"]}><CreateLeaveType /></ProtectedRoute>} />
            <Route path="edit-leave-type/:id" element={<ProtectedRoute requiredPermissions={["Edit_Leave_Type"]}><EditLeaveType /></ProtectedRoute>} />
            <Route path="view-leave-types" element={<ProtectedRoute requiredPermissions={["view_leave_types"]}><LeaveTypes /></ProtectedRoute>} />
            <Route path="Employees-Remaining-Leaves" element={<ProtectedRoute requiredPermissions={["manage_users"]}><EmployeesRemainingLeaves /></ProtectedRoute>} />
            <Route path="view-Designations" element={<ProtectedRoute requiredPermissions={["view_designation"]}><Designations /></ProtectedRoute>} />
            <Route path="create-Designation" element={<ProtectedRoute requiredPermissions={["create_designation"]}><CreateDesignation /></ProtectedRoute>} />
            <Route path="View-districts" element={<ProtectedRoute requiredPermissions={["districts_view"]}><Viewdistricts /></ProtectedRoute>} />
            <Route path="View-Municipalitie" element={<ProtectedRoute requiredPermissions={["municipalities_view"]}><ViewMunicipalitie /></ProtectedRoute>} />
            <Route path="Create-Districts" element={<ProtectedRoute requiredPermissions={["districts_create"]}><CreateDistricts /></ProtectedRoute>} />
            <Route path="Create-Municipality" element={<ProtectedRoute requiredPermissions={["municipalities_create"]}><CreateMunicipality /></ProtectedRoute>} />
            <Route path="View-Admin" element={<ProtectedRoute requiredPermissions={["municipalities_admin_view"]}><ViewAdmin /></ProtectedRoute>} />
            <Route path="Create-Admin" element={<ProtectedRoute requiredPermissions={["municipalities_admin_create"]}><CreateAdmin /></ProtectedRoute>} />   
            <Route path="parkGeofence" element={<ProtectedRoute requiredPermissions={["view_geofence"]}><ParkGeofence /></ProtectedRoute>} /> 
            <Route path="Create-Tasks-Admin" element={<ProtectedRoute requiredPermissions={["Create_tasks_admin"]}><CreateTasksAdmin /></ProtectedRoute>} />
            <Route path="Contact-Details" element={<ProtectedRoute requiredPermissions={["Contact_Details"]}><ContactDetails /></ProtectedRoute>} />
            <Route path="Resume-Details" element={<ProtectedRoute requiredPermissions={["Resume_Details"]}><ResumeDetails /></ProtectedRoute>} />
            <Route path="blogs" element={<ProtectedRoute requiredPermissions={["view_blog"]}><Blog /></ProtectedRoute>} />
            <Route path="jobs" element={<ProtectedRoute requiredPermissions={["view_job_post"]}><Job /></ProtectedRoute>} />
            <Route path="create-office" element={<ProtectedRoute requiredPermissions={["create_office"]}><CreateOffice /></ProtectedRoute>} />
            <Route path="view-offices" element={<ProtectedRoute requiredPermissions={["view_office"]}><ViewOffice /></ProtectedRoute>} />
            <Route path="create-shift" element={<ProtectedRoute requiredPermissions={["create_shift"]}><CreateShift /></ProtectedRoute>} />
            <Route path="view-shifts" element={<ProtectedRoute requiredPermissions={["view_shift"]}><ViewShifts /></ProtectedRoute>} />
            <Route path="attendance-report" element={<ProtectedRoute requiredPermissions={["view_attendance_report"]}><AttendanceReport /></ProtectedRoute>} />
             <Route path="direct-Attendance" element={<ProtectedRoute requiredPermissions={["direct_attendance_entry"]}><DirectAttendance /></ProtectedRoute>} />

          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
